import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityProvider {

  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  async load() {
    return new Promise(async (resolve) => {
      try {
        const hasStoredSession = !!localStorage.getItem('roleName');
        if (hasStoredSession && !this.authService.restoreSession()) {
          this.authService.clearSession();
          this.router.navigate(['login']);
        }
        resolve(true);
      } catch (e) {
        this.authService.clearSession();
        this.router.navigate(['login']);
        resolve(false);
      }
    });
  }
}
